module.exports = __webpack_public_path__ + "185ef96e79d14b6d8efaac5782acc474.svg";